module.exports = __webpack_public_path__ + "media/images/icon__point--white@2x-fbf4835280d5a6dad6f23adb4413de1c.png";